// ======================================= ======================================= GSAP
gsap.registerPlugin(ScrollTrigger);
// ======================================= Split extra div inside lines
// function createSplitLines(selector) {
//   const el = document.querySelector(selector);
//   if (!el) return null;
//   const split = new SplitText(el, { type: "lines" });
//   const wrappers = split.lines.map(line => {
//     const wrapper = document.createElement('div');
//     wrapper.classList.add('line-wrapper');
//     wrapper.style.overflow = 'hidden';
//     line.parentNode.insertBefore(wrapper, line);
//     wrapper.appendChild(line);
//     return wrapper;
//   });
//   return {
//     split,
//     lines: split.lines,
//     wrappers,
//     revert: () => {
//       wrappers.forEach(w => {
//         const parent = w.parentNode;
//         if (!parent) return;
//         while (w.firstChild) parent.insertBefore(w.firstChild, w);
//         parent.removeChild(w);
//       });
//       split.revert();
//     }
//   };
// }
// =================== EXAMPLE
// const coH2Title = createSplitLines('.co-home-1-bottom-h1');
// gsap.from(coH2Title.lines, {
//   // yPercent: 100,
//   opacity: 0,
//   duration: 1,
//   ease: "power2.inOut",
//   stagger: 0.25,
//   delay: 0.5,
//   onComplete: () => { coH2Title.revert(); }
// });
// ======================================= SECTION 1
const toVhPx = v => window.innerHeight * (parseFloat(v) / 100);
const toVwPx = v => window.innerWidth  * (parseFloat(v) / 100);
gsap.set('.co-home-1-logo-frame', { top: toVhPx(50) });
gsap.set('.co-home-1-logo-frame-2', { scale: 1.2 });
gsap.set('.co-home-1-logo-overlay', { opacity: 1 });
gsap.set('.co-home-1-logo', { y: "60%" });
gsap.set('.shopify-section-group-header-group>sticky-header', { yPercent: -100, opacity: 0 });
let coH1Tl = gsap.timeline({ defaults: { ease: "power2.inOut" }, delay: 0.35 });
coH1Tl.to('.co-home-1-logo-frame-2', { scale: 1, duration: 0.75 });
coH1Tl.to('.co-home-1-logo', { y: 0, duration: 0.75 }, "-=0.75");
coH1Tl.to('.co-home-1-logo-frame', {
  top: () => toVwPx(20),
  duration: 0.75,
  onComplete: () => {
    const el = document.querySelector('.co-home-1-logo-frame');
    el.style.top = '20vw';
  }
}, "-=0.75");
coH1Tl.to('.co-home-1-logo-overlay', { 
  opacity: 0, 
  duration: 0.75,
  onComplete: () => {
    const el = document.querySelector('.co-home-1-logo-overlay');
    el.style.display = 'none';
  }
}, "-=0.75");
coH1Tl.to('.shopify-section-group-header-group>sticky-header', { yPercent: 0, opacity: 1, duration: 0.75 }, "-=0.75");
coH1Tl.to('.co-home-1-media-image', { scale: 0.92, opacity: 1, duration: 0.75 }, "-=0.7");
coH1Tl.to('.co-home-1-media-image-mobile', { scale: 0.92, opacity: 1, duration: 0.75 }, "-=0.75");
coH1Tl.to('.co-home-1-sub-logo', { opacity: 1, duration: 0.75 }, "-=0.35");
gsap.from('.co-home-1-bottom-h1', { 
  duration: 1, 
  opacity: 0,
  ease: "power2.inOut",
  delay: 0.75,
});
gsap.from('.co-home-1-bottom-buttons', { 
  duration: 1, 
  opacity: 0,
  ease: "power2.inOut",
  delay: 0.75,
});
// trigger scrub
gsap.set('.co-home-1-media img', { top: "-9%" });
gsap.to('.co-home-1-media img', {
  scrollTrigger: {
    start: 'top top',
    end: 'bottom top',
    trigger: '.co-home-1-media',
    scrub: true
  },
  top: "0%"
});
// ======================================= SECTION 2
// slider
const coSwiper2 = new Swiper('.co-home-2-slider', {
  slidesPerView: "auto",
  loop: true,
  speed: 400,
  watchSlidesProgress: true,
  mousewheel: {
    forceToAxis: true,
  },
  // autoplay: {
  //       delay: 3000,
  //       // disableOnInteraction: false,
  //     },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    0: {
      centeredSlides: true,
    },
    750: {
      centeredSlides: false,
    },
  },
});
// trigger
gsap.from('.co-home-2', { 
  duration: 1, 
  y: 20,
  opacity: 0,
  ease: "power2.inOut",
  delay: 0.75,
});
gsap.set('.co-home-2-frame', { y: 20, opacity: 0 });
gsap.to('.co-home-2-frame', {
  scrollTrigger: {
    trigger: '.co-home-2',
    start: 'top bottom',
    end: 'bottom top'
  },
    duration: 1, 
    y: 0,
    opacity: 1,
    ease: "power2.inOut"
});
// ======================================= SECTION 3
gsap.set('.co-home-3-frame', { y: 20, opacity: 0 });
gsap.to('.co-home-3-frame', {
  scrollTrigger: {
    trigger: '.co-home-3',
    start: 'top 95%',
    end: 'bottom top'
  },
    duration: 1, 
    y: 0,
    opacity: 1,
    ease: "power2.inOut"
});
// ======================================= SECTION 4
gsap.set('.co-home-4-frame', { y: 20, opacity: 0 });
gsap.to('.co-home-4-frame', {
  scrollTrigger: {
    trigger: '.co-home-4',
    start: 'top 95%',
    end: 'bottom top'
  },
    duration: 1, 
    y: 0,
    opacity: 1,
    ease: "power2.inOut"
});
// scrub
gsap.set('.co-home-4-right-frame img', { scale: 0.87 });
gsap.to('.co-home-4-right-frame img', {
  scrollTrigger: {
    start: 'top bottom',
    end: 'bottom top',
    trigger: '.co-home-4',
    scrub: true
  },
  scale: 1
});
// ======================================= SECTION 5
gsap.set('.co-home-5-frame', { opacity: 0 });
gsap.to('.co-home-5-frame', {
  scrollTrigger: {
    trigger: '.co-home-5',
    start: 'top 95%',
    end: 'bottom top'
  },
    duration: 1,
    opacity: 1,
    ease: "power2.inOut"
});
// ======================================= SECTION 6
gsap.set('.co-home-6-frame', { y: 20, opacity: 0 });
gsap.to('.co-home-6-frame', {
  scrollTrigger: {
    trigger: '.co-home-6',
    start: 'top 95%',
    end: 'bottom top'
  },
    duration: 1,
    opacity: 1,
    y: 0,
    ease: "power2.inOut"
});
// scrub
// gsap.set('.co-home-6-content-image-wrapper', { top: "0%" });
// gsap.to('.co-home-6-content-image-wrapper', {
//   scrollTrigger: {
//     start: 'top bottom',
//     end: 'bottom top',
//     trigger: '.co-home-6',
//     scrub: true
//   },
//   top: "-15%"
// });
// ======================================= SECTION 7
gsap.set('.co-home-7-cell-1', { y: 0, opacity: 0 });
gsap.to('.co-home-7-cell-1', {
  scrollTrigger: {
    trigger: '.co-home-7-cell-1',
    start: 'top 95%',
    end: 'bottom top'
  },
    duration: 1,
    opacity: 1,
    y: 0,
    ease: "power2.inOut"
});
gsap.set('.co-home-7-cell-2', { y: 0, opacity: 0 });
gsap.to('.co-home-7-cell-2', {
  scrollTrigger: {
    trigger: '.co-home-7-cell-2',
    start: 'top 95%',
    end: 'bottom top'
  },
    duration: 1,
    opacity: 1,
    y: 0,
    ease: "power2.inOut"
});
gsap.set('.co-home-7-cell-3', { y: 0, opacity: 0 });
gsap.to('.co-home-7-cell-3', {
  scrollTrigger: {
    trigger: '.co-home-7-cell-3',
    start: 'top 95%',
    end: 'bottom top'
  },
    duration: 1,
    opacity: 1,
    y: 0,
    ease: "power2.inOut"
});
gsap.set('.co-home-7-cell-4', { y: 0, opacity: 0 });
gsap.to('.co-home-7-cell-4', {
  scrollTrigger: {
    trigger: '.co-home-7-cell-4',
    start: 'top 95%',
    end: 'bottom top'
  },
    duration: 1,
    opacity: 1,
    y: 0,
    ease: "power2.inOut"
});
// ======================================= SECTION 8
// trigger
gsap.set('.co-home-8-frame', { y: 20, opacity: 0 });
gsap.to('.co-home-8-frame', {
  scrollTrigger: {
    trigger: '.co-home-8',
    start: 'top 95%',
    end: 'bottom top'
  },
    duration: 1,
    opacity: 1,
    y: 0,
    ease: "power2.inOut"
});
// slider
// const coSwiper8 = new Swiper('.co-home-8-slider', {
//   slidesPerView: "auto",
//   loop: true,
//   speed: 400,
//   watchSlidesProgress: true,
//   mousewheel: {
//     forceToAxis: true,
//   },
//   // autoplay: {
//   //       delay: 3000,
//   //       // disableOnInteraction: false,
//   //     },
//   // navigation: {
//   //   nextEl: ".swiper-button-next",
//   //   prevEl: ".swiper-button-prev",
//   // },
//   breakpoints: {
//     0: {
//       centeredSlides: true,
//     },
//     750: {
//       centeredSlides: true,
//     },
//   },
// });